import { render } from "./InformationsGroupe.vue?vue&type=template&id=3191d913"
import script from "./InformationsGroupe.vue?vue&type=script&lang=js"
export * from "./InformationsGroupe.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__